import { render, staticRenderFns } from "./pay-user.vue?vue&type=template&id=321b313a&scoped=true"
import script from "./pay-user.vue?vue&type=script&lang=js"
export * from "./pay-user.vue?vue&type=script&lang=js"
import style0 from "./pay-user.vue?vue&type=style&index=0&id=321b313a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b313a",
  null
  
)

export default component.exports